export const BOOK_SELECTED = 'BOOK_SELECTED'
export const BOOK_NEXT_CLICKED = 'BOOK_NEXT_CLICKED'
export const BOOK_PREV_CLICKED = 'BOOK_PREV_CLICKED'
